import {ReactComponent as CheckIcon} from 'icons/check.svg'

type Props = {
  title: string
  description: React.ReactNode
}

export const Item = ({title, description}: Props) => {
  return (
    <div className="flex gap-2">
      <CheckIcon className="mt-1 text-theme" />
      <div className="flex flex-col gap-1">
        <div className="font-bold">{title}</div>
        <div>{description}</div>
      </div>
    </div>
  )
}
